// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/Rubik-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/Rubik-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./assets/RobotoMono.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: 'Rubik', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: var(--main-background-color);
  color: var(--main-foreground-color);
}

code {
  font-family: 'RobotoMono', source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

input,
textarea,
button,
select,
a,
* {
  -webkit-tap-highlight-color: transparent;
}

:root {
  --light-grey-color: #8db3c4;
  --muted-grey-color: #112336;
  --main-background-color: #0d1b2a;
  --main-foreground-color: #5dbde8;
  --header-color: #ffffff;
  --secondary-color: #ff9a10;
  --soft-red-color: #e05555;
}

@font-face {
  font-family: 'Rubik';
  font-style: normal;
  font-weight: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('truetype');
}

@font-face {
  font-family: 'Rubik';
  font-style: normal;
  font-weight: lighter;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('truetype');
}

@font-face {
  font-family: 'Rubik';
  font-style: normal;
  font-weight: bold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('truetype');
}

@font-face {
  font-family: 'RobotoMono';
  font-style: normal;
  font-weight: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('truetype');
}

.clickable:hover {
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,gCAAgC;EAChC,mCAAmC;EACnC,kCAAkC;EAClC,8CAA8C;EAC9C,mCAAmC;AACrC;;AAEA;EACE;aACW;AACb;;AAEA;;;;;;EAME,wCAAwC;AAC1C;;AAEA;EACE,2BAA2B;EAC3B,2BAA2B;EAC3B,gCAAgC;EAChC,gCAAgC;EAChC,uBAAuB;EACvB,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,+DAAuD;AACzD;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,oBAAoB;EACpB,+DAAqD;AACvD;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;EACjB,+DAAuD;AACzD;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,+DAAoD;AACtD;;AAEA;EACE,eAAe;AACjB","sourcesContent":["body {\n  margin: 0;\n  font-family: 'Rubik', sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background-color: var(--main-background-color);\n  color: var(--main-foreground-color);\n}\n\ncode {\n  font-family: 'RobotoMono', source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\ninput,\ntextarea,\nbutton,\nselect,\na,\n* {\n  -webkit-tap-highlight-color: transparent;\n}\n\n:root {\n  --light-grey-color: #8db3c4;\n  --muted-grey-color: #112336;\n  --main-background-color: #0d1b2a;\n  --main-foreground-color: #5dbde8;\n  --header-color: #ffffff;\n  --secondary-color: #ff9a10;\n  --soft-red-color: #e05555;\n}\n\n@font-face {\n  font-family: 'Rubik';\n  font-style: normal;\n  font-weight: normal;\n  src: url(./assets/Rubik-Regular.ttf) format('truetype');\n}\n\n@font-face {\n  font-family: 'Rubik';\n  font-style: normal;\n  font-weight: lighter;\n  src: url(./assets/Rubik-Light.ttf) format('truetype');\n}\n\n@font-face {\n  font-family: 'Rubik';\n  font-style: normal;\n  font-weight: bold;\n  src: url(./assets/Rubik-Regular.ttf) format('truetype');\n}\n\n@font-face {\n  font-family: 'RobotoMono';\n  font-style: normal;\n  font-weight: normal;\n  src: url(./assets/RobotoMono.ttf) format('truetype');\n}\n\n.clickable:hover {\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
